export const COPY_MEAL_PLAN = 'COPY_MEAL_PLAN';
export const VIEW_MEAL_PLAN = 'VIEW_MEAL_PLAN';
export const EDIT_MEAL_PLAN = 'EDIT_MEAL_PLAN';
export const ADD_MEAL_PLAN = 'ADD_MEAL_PLAN';

/** MEAL PLANS REQUESTS */
export const LOAD_MEAL_PLANS_SELECT_ITEMS = 'LOAD_MEAL_PLANS_SELECT_ITEMS';
export const LOAD_MEAL_PLANS_SELECT_ITEMS_SUCCESS = 'LOAD_MEAL_PLANS_SELECT_ITEMS_SUCCESS';
export const LOAD_MEAL_PLANS_SELECT_ITEMS_ERROR = 'LOAD_MEAL_PLANS_SELECT_ITEMS_ERROR';

export const LOAD_MEAL_PLANS_REQUESTS = 'LOAD_MEAL_PLANS_REQUESTS';
export const LOAD_MEAL_PLANS_REQUESTS_SUCCESS = 'LOAD_MEAL_PLANS_REQUESTS_SUCCESS';
export const LOAD_MEAL_PLANS_REQUESTS_ERROR = 'LOAD_MEAL_PLANS_REQUESTS_ERROR';

export const SEARCH_MEAL_PLANS_REQUESTS = 'SEARCH_MEAL_PLANS_REQUESTS';
export const SEARCH_MEAL_PLANS_REQUESTS_SUCCESS = 'SEARCH_MEAL_PLANS_REQUESTS_SUCCESS';
export const SEARCH_MEAL_PLANS_REQUESTS_ERROR = 'SEARCH_MEAL_PLANS_REQUESTS_ERROR';
export const CLEAN_MEAL_PLANS_REQUESTS = 'CLEAN_MEAL_PLANS_REQUESTS';